import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaidPickerComponent } from './baid-picker/baid-picker.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [CommonModule, FormsModule],
  declarations: [BaidPickerComponent]
})
export class SharedBaidPickerModule {}
